// extracted by mini-css-extract-plugin
module.exports = {"progress":"DocumentAddButton_progress__MZb_M","addDocument":"DocumentAddButton_addDocument__eUvvJ"};